import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error"
}
const _hoisted_2 = { class: "step-btns" }

import { ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import DialogueModal from "@/components/modals/DialogueModal.vue";
import Modal from "@/components/shared/Modal.vue";
import NextButton from "@/components/shared/NextButton.vue";
import RefiProgramLoanOptions from "@/components/refi-loan-configuration/RefiProgramLoanOptions.vue";
import CircleLoader from "@/components/shared/CircleLoader.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RefiLoanConfigurationModal',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const store = useStore();

const emit = __emit;

const showDialogueModal = ref<boolean>(false);

const gettingData = ref<boolean>(true);
const savingChanges = ref<boolean>(false);
const discardingChanges = ref<boolean>(false);

const updatingLoanConfiguration = computed<boolean>(
  () => store.state.refiLoanConfigurationModule.updatingLoanConfiguration,
);
const updateLoanConfigurationError = computed<boolean>(
  () => store.state.refiLoanConfigurationModule.updateLoanConfigurationError,
);
const updateLoanConfigurationErrorText = computed<boolean>(
  () => store.state.refiLoanConfigurationModule.updateLoanConfigurationErrorText,
);

function openDialogueModal() {
  showDialogueModal.value = true;
}
function handleDialogueModal() {
  store.dispatch("applicationInfoModule/discardChanges");
  store.dispatch("applicationInfoModule/closeModal", "InterestRateAndLoanTerm");
}
function closeModal() {
  openDialogueModal();
}
function cancelChanges() {
  discardingChanges.value = true;
  handleDialogueModal();
}
async function confirmChanges() {
  savingChanges.value = true;
  const response = await store.dispatch("refiLoanConfigurationModule/updateLoanConfiguration");

  savingChanges.value = response;

  if (response) {
    // Get latest loan details
    await store.dispatch(
      "applicationInfoModule/getRefiDetails",
      store.state?.appData?.application?.id,
    );

    // Close
    store.dispatch("applicationInfoModule/closeModal", "InterestRateAndLoanTerm");
  }
}

async function getRefiRatePlans() {
  discardingChanges.value = false;
  savingChanges.value = false;
  await store.dispatch(
    "refiLoanConfigurationModule/getRefiRatePlans",
    store?.state?.appData?.application?.id,
  );
  gettingData.value = false;
}

onMounted(() => {
  store.dispatch("refiLoanConfigurationModule/resetRefiLoanConfigurationModal");
  getRefiRatePlans();
});
watch(
  () => updateLoanConfigurationError.value,
  (value: boolean) => {
    if (value) {
      savingChanges.value = false;
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "loan-details-modal",
    closeBtn: true,
    onClose: closeModal
  }, {
    footer: _withCtx(() => [
      (updateLoanConfigurationError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(updateLoanConfigurationErrorText.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(NextButton, {
          onClick: _withModifiers(cancelChanges, ["prevent"]),
          text: "Cancel",
          loading: discardingChanges.value,
          disabled: savingChanges.value || discardingChanges.value
        }, null, 8, ["loading", "disabled"]),
        _createVNode(NextButton, {
          onClick: _withModifiers(confirmChanges, ["prevent"]),
          text: "Save Changes",
          loading: savingChanges.value,
          disabled: savingChanges.value || discardingChanges.value
        }, null, 8, ["loading", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      (gettingData.value)
        ? (_openBlock(), _createBlock(CircleLoader, {
            key: 0,
            inline: true
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(RefiProgramLoanOptions),
            (showDialogueModal.value === true)
              ? (_openBlock(), _createBlock(DialogueModal, {
                  key: 0,
                  onCancel: _cache[0] || (_cache[0] = ($event: any) => (showDialogueModal.value = false)),
                  onConfirm: handleDialogueModal,
                  title: `Quit editing?`,
                  msg: `Any changes you\'ve made so far will not be saved`,
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No'
                }))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    _: 1
  }))
}
}

})